import AxAPI from '@/api';
import * as E from '@/enums';
import * as I from '@/interfaces';

export interface ApiResp<T> {
  result: number;
  data: T;
  errorMsg: string;
}

export interface AxAccount {
  name: string;
}

export interface AxLatestInfo {
  controller: string;
  action: string;
  groupId: number;
}

export type AxNavigate = AxLatestInfo;

export interface AxMenu {
  idx: number;
  group: string;
  groupName: string;
  controllerName: string;
  actionName: string | null;
  menuName: string | null;
  privType: number;
  monitorGroupID: number;
  listChildMenu: AxMenu[];
}

export interface AxPageBase {
  setLoading: (b: boolean) => void;
  getLoading: () => boolean;
  getLoginData: () => I.Account | undefined;
  setLoginData: (loginData: I.Account) => void;
  getAppFrame: () => E.AppFrame;
  setAppFrame: (frame: E.AppFrame) => void;
  showConfirmModal: (title: string, text: string, buttons?: string[]) => Promise<number>;
  showErrorModal: (title: string, text: string) => Promise<number>;
  getZoneList: () => I.AxZone[];
  getZoneNames: () => string[];
  userLogin: (data: I.ApiResp<I.Account>) => void;
  userLogout: () => void;

  API: AxAPI;
  latestInfo: I.AxLatestInfo;
  isDevelopment: boolean;
}

export interface AxTimeBox {
  month: string;
  day: string;
  hour: string;
  minute: string;
}

export interface AxSessionTime {
  hour: string;
  minute: string;
}

export interface AxZone {
  code: number;
  name: string;
  etc: string;
}

export interface AxGroupListPanel<TGroup, TItem> {
  groups: TGroup[];
  items: TItem[];
  group: number;
  item: number;
}

export class DialogParam<T> {
  id?: number;
  type: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props: T;

  constructor(type: string, props: T) {
    this.type = type;
    this.props = props;
  }
}

export interface DialogOptions {
  title: string;
  param: I.DataParam;
  single?: boolean;
  showSelect?: boolean;
  itemKey?: string;
}

export class DataParam {
  items: unknown[];
  selected: unknown[];
  headers?: unknown[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  callback: (...args: any[]) => Promise<void>;

  constructor() {
    this.items = [];
    this.selected = [];
    this.headers = [];
    this.callback = async () => {};
  }
}
